// extracted by mini-css-extract-plugin
export default {"initials":"user-ava_initials__0X159"};